function isHubApiPath(pathname: string): boolean {
  return pathname === '/api' || pathname.startsWith('/api/');
}

function isAbsoluteHttpUrl(url: string): boolean {
  return url.startsWith('http://') || url.startsWith('https://');
}

/**
 * True when an Axios request should attach a live ID token from
 * getClientIdToken (API Gateway invoke URL or Hub /api).
 */
export function axiosRequestNeedsLiveIdToken(
  url: string | null | undefined,
  invokeUrl?: string | null
): boolean {
  if (typeof url !== 'string' || url.length === 0) {
    return false;
  }

  if (
    isAbsoluteHttpUrl(url) &&
    typeof invokeUrl === 'string' &&
    invokeUrl.length > 0
  ) {
    try {
      const requestUrl = new URL(url);
      const targetUrl = new URL(invokeUrl);
      const targetPath = targetUrl.pathname.replace(/\/+$/, '');
      if (
        requestUrl.origin === targetUrl.origin &&
        (targetPath === '' ||
          requestUrl.pathname === targetPath ||
          requestUrl.pathname.startsWith(`${targetPath}/`))
      ) {
        return true;
      }
    } catch {
      // Fall through to Hub /api checks.
    }
  }

  const pathOnly = url.split('?')[0];
  if (isHubApiPath(pathOnly)) {
    return true;
  }

  try {
    const parsed = new URL(url);
    if (typeof window === 'undefined') {
      return false;
    }
    return (
      parsed.origin === window.location.origin && isHubApiPath(parsed.pathname)
    );
  } catch {
    return false;
  }
}
